import { BREAKPOINT_MEDIUM } from '@big-red-group/storefront-common-ui'
import styled from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
`
export const ExtraGroupsContainer = styled.div`
  display: grid;
  grid-template-columns: 100%;
  gap: 30px;

  &:not(:last-child) {
    margin-bottom: 30px;
  }
`
export const ExtraGroup = styled.div`
  border: 1px solid var(--grey-50);
  position: relative;
  padding: 20px 20px 10px 20px;
  border-radius: 8px;
`
export const GroupHeader = styled.div`
  position: absolute;
  bottom: 100%;
  left: 10px;
  transform: translateY(50%);
  background: white;
  padding: 0 10px;
  max-width: 80%;

  mark {
    background: transparent;
    font-weight: var(--font-bold);
    text-decoration: underline;
  }
`
export const OptionType = styled.div``
export const Title = styled.span`
  display: block;
  font-weight: var(--font-bold);
  line-height: 1.4;
  margin-bottom: 25px;
  font-size: 16px;
`
export const Session = styled.h3`
  margin-bottom: 28px;

  &:not(:first-of-type) {
    margin-top: 40px;
  }
`
export const OptionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0;

  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    align-items: flex-start;

    &:not(:last-child) {
      margin-bottom: 30px;
    }
  }
`
export const OptionInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    position: relative;
    top: -2px;
  }
`

export const ExtraDescription = styled.div`
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  position: relative;
  padding: 5px 0;
  pointer-events: none;

  ::after {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent black transparent;
    pointer-events: none;
  }
`
export const OptionPriceWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    flex-direction: column;
    align-items: flex-end;
    gap: 10px;
  }
`
export const OptionNameWrapper = styled.div`
  font-weight: var(--font-regular);
  color: var(--text-primary);
  margin-right: 10px;
  font-size: 14px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  > div {
    margin: 0;
    top: 1px;
    margin-right: 6px;

    > div {
      top: calc(100% + 13px);

      &:after {
        left: 10px;
      }
    }
  }
  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    align-items: flex-start;

    > div {
      top: -2px;
    }
  }
`
export const OptionName = styled.span`
  font-weight: var(--font-regular);
  font-size: 14px;

  span {
    color: grey;
    margin-left: 4px;
  }
`
export const FromPrice = styled.span`
  font-weight: var(--font-regular);
  color: var(--sale);
  margin-right: 8px;
  text-decoration: line-through;
  font-size: 14px;
`
export const Price = styled.span`
  font-weight: var(--font-regular);
  margin-right: 20px;
  font-size: 14px;

  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    margin-right: 0;
    font-weight: var(--font-medium);
  }
`
export const Quantity = styled.span`
  font-weight: var(--font-regular);
  margin: 0 12px;
  min-width: 20px;
  text-align: center;
  font-size: 14px;
`
export const Button = styled.button`
  cursor: pointer;
  font-weight: var(--font-medium);
  font-size: 18px;
  border: none;
  background: whitesmoke;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;
`
